import type { FeatureEntry } from "../rules/features";

// A Business unit or Pricing plan the form offers. A retired one is hidden from the form but old tickets keep it.
export interface ValueEntry {
  label: string;
  retired?: boolean;
}

export interface FormLists {
  features: FeatureEntry[];
  businessUnits: ValueEntry[];
  pricingPlans: ValueEntry[];
}

export interface StoredFormLists extends FormLists {
  // 0 until an admin first saves; the lists are then the defaults.
  version: number;
  updatedBy?: string;
  updatedAt?: string;
}

export type ListKind = keyof FormLists;

export const LIST_TITLES: Record<ListKind, string> = {
  features: "Feature",
  businessUnits: "Business unit",
  pricingPlans: "Pricing plan",
};

// The labels the form offers now.
export const activeLabels = (entries: readonly { label: string; retired?: boolean }[]): string[] =>
  entries.filter((entry) => entry.retired !== true).map((entry) => entry.label);
